var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"summary",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v("Resumen")]),_c('img',{attrs:{"src":"https://golstatsimages.blob.core.windows.net/todoelfut/icn_play.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }